import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';
import { Common, RequestBodyCommon } from '../models/commonConfig.model';
import { map } from 'rxjs/operators';
import { ReqGetToken, TokenResponse } from '../models/inquiryRegister.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private lineServiceUrl: string = environment.endpointBackend + '/api';
  constructor(
    private http: HttpClient,
  ) { }

  // 1_2125
  apiGetCommonConfig(payload:RequestBodyCommon): Observable<PayloadResponse<Common>> {
    return this.http.post<ApiResponse<Common>>(this.lineServiceUrl + '/line/getCommonConfig', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }
  getTokenUrl(payload:ReqGetToken) {
        return this.http.post<TokenResponse>(this.lineServiceUrl + '/services/verify/getTokenUrl', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.data : null
      )
    )
  }
}
